__turbopack_context__.v({
  "actions": "styles-module__4um7mq__actions",
  "avatarItem": "styles-module__4um7mq__avatarItem",
  "avatars": "styles-module__4um7mq__avatars",
  "content": "styles-module__4um7mq__content",
  "hero": "styles-module__4um7mq__hero",
  "inner": "styles-module__4um7mq__inner",
  "primaryButton": "styles-module__4um7mq__primaryButton",
  "rating": "styles-module__4um7mq__rating",
  "ratingText": "styles-module__4um7mq__ratingText",
  "socialProof": "styles-module__4um7mq__socialProof",
  "stars": "styles-module__4um7mq__stars",
  "subtitle": "styles-module__4um7mq__subtitle",
  "title": "styles-module__4um7mq__title",
  "titleAccent": "styles-module__4um7mq__titleAccent",
});
